<div aria-live="polite" class="empty-state" role="status">
  <h3>{{ emptyStateComponent()?.title }}</h3>
  <p>{{
      emptyStateComponent()?.description
    }}</p>
</div>
